// LIST
export const FETCH_CONTACTS = "app/CONTACTS/FETCH_CONTACTS";
export const FETCH_CONTACTS_SUCCESS = "app/CONTACTS/FETCH_CONTACTS_SUCCESS";
export const FETCH_CONTACTS_FAILURE = "app/CONTACTS/FETCH_CONTACTS_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/CONTACTS/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/CONTACTS/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/CONTACTS/GET_VIEW_DATA_FAILURE";

// ADD
export const ADD_CONTACTS = "app/CONTACTS/ADD_CONTACTS";
export const ADD_CONTACTS_SUCCESS = "app/CONTACTS/ADD_CONTACTS_SUCCESS";
export const ADD_CONTACTS_FAILURE = "app/CONTACTS/ADD_CONTACTS_FAILURE";

// EDIT
export const EDIT_CONTACTS = "app/CONTACTS/EDIT_CONTACTS";
export const EDIT_CONTACTS_SUCCESS = "app/CONTACTS/EDIT_CONTACTS_SUCCESS";
export const EDIT_CONTACTS_FAILURE = "app/CONTACTS/EDIT_CONTACTS_FAILURE";

// DELETE
export const DELETE_CONTACTS = "app/CONTACTS/DELETE_CONTACTS";
export const DELETE_CONTACTS_SUCCESS = "app/CONTACTS/DELETE_CONTACTS_SUCCESS";
export const DELETE_CONTACTS_FAILURE = "app/CONTACTS/DELETE_CONTACTS_FAILURE";

export const OPEN_ADD_MODAL = "app/CONTACTS/OPEN_ADD_MODAL";
export const OPEN_EDIT_MODAL = "app/CONTACTS/OPEN_EDIT_MODAL";
export const CLOSE_MODAL = "app/CONTACTS/CLOSE_MODAL";
